import React from "react";

// components
import { Navbar } from "src/components";
import Content from "src/components/Profile/Content/Content";

const Profile = () => {
  return (
    <div>
      <Navbar mobHide />
      <Content />
    </div>
  );
};

export default Profile;
